export enum DetectedType {
  AST,
  Unknown,
}
